import type {Polygon} from 'geojson';

function isLoadingArea(area: Area): area is LoadingArea {
    return !area.isGeometryLoaded;
}

function isComplexArea(area: Area): area is ComplexArea {
    return !isLoadingArea(area) && !area.isGeometryEditable;
}

export default function (area: Area, interaction?: InteractionState): Polygon | undefined {
    if (isLoadingArea(area)) return;

    if (isComplexArea(area)) return area.geometry;

    const points = Object.values(area.points)
        .sort((p1, p2) => p1.properties.order - p2.properties.order)
        .map((point: AreaPoint) => {
            // The Gaia API needs each coordinate to have a z coordinate
            return [
                point.geometry.coordinates[0],
                point.geometry.coordinates[1],
                point.geometry.coordinates[2] || 0,
            ];
        });

    if (
        interaction &&
        interaction.type === 'editingArea' &&
        interaction.subtype === 'appendingPoint' &&
        interaction.mode === 'create' &&
        interaction.cursorLngLat &&
        interaction.area.properties.localId === area.properties.localId
    ) {
        points.push(interaction.cursorLngLat.toArray());
    }

    if (points.length < 3) return;

    return {
        type: 'Polygon',
        // The first and last coordinate of a valid polygon must be the same
        coordinates: [[...points, points[0]]],
    };
}
